import { PREFER_NOT_TO_USE_TITLE } from "@albertine/types";

export const PREDEFINED_TITLES = ["Mr", "Ms", "Mrs", "Miss", "Dr", "Prof"] as const;

export type PredefinedTitle = (typeof PREDEFINED_TITLES)[number];

export const TITLE_SELECT_OPTIONS = {
    PREFER_NOT_TO_USE: "Prefer not to use",
    OTHER: "Other",
    EMPTY: "",
} as const;

export function isPredefinedTitle(
    title: string | null | undefined,
): title is PredefinedTitle {
    if (!title) return false;

    return PREDEFINED_TITLES.includes(title as PredefinedTitle);
}

// Three states: null/undefined → not filled, PREFER_NOT_TO_USE_TITLE → explicit opt-out, other → predefined or custom
export function getTitleSelectValue(title: string | null | undefined): string {
    if (title === PREFER_NOT_TO_USE_TITLE) {
        return TITLE_SELECT_OPTIONS.PREFER_NOT_TO_USE;
    }

    if (!title) {
        return TITLE_SELECT_OPTIONS.EMPTY;
    }

    if (isPredefinedTitle(title)) {
        return title;
    }

    return TITLE_SELECT_OPTIONS.OTHER;
}

export function shouldDisplayTitle(title: string | null | undefined): boolean {
    if (!title) return false;
    if (title === PREFER_NOT_TO_USE_TITLE) return false;
    if (title === TITLE_SELECT_OPTIONS.OTHER) return false;

    return true;
}
